import React, { useState, useEffect } from "react";

const LinkedInRetargeting = ()=>{
  return <img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=3803834&fmt=gif" />
}

export default LinkedInRetargeting